import { Text as MantineText, TextProps } from '@mantine/core';

export type ITextProps = TextProps;

/** @registry Design-layer pass-through over Mantine Text; import this instead of @mantine/core Text outside src/design. */
export const Text = MantineText;
